export default [
	{
		path: "/main/CustomerApplication",
		name: "CustomerApplication",
		meta: {
			title: "转介绍客户申请" 
		},
		component: () =>
			import("@/views/Home/ChannelAgents/CustomerApplication/index.vue"),
	},
	{
		path: "/main/ApplicationDetail",
		name: "ApplicationDetail",
		meta: {
			title: "转介绍客户申请详情"
		},
		component: () =>
			import("@/views/Home/ChannelAgents/ApplicationDetail/index.vue"),
	},
	{
		path: "/main/PerformanceManagement",
		name: "PerformanceManagement",
		meta: {
			title: "转介绍业绩管理" 
		},
		component: () =>
			import("@/views/Home/ChannelAgents/PerformanceManagement/index.vue"),
	},
	{
		path: "/main/CreditUsageRecord",
		name: "CreditUsageRecord",
		meta: {
			title: "额度使用记录" 
		},
		component: () =>
			import("@/views/Home/ChannelAgents/CreditUsageRecord/index.vue"),
	},
	{
		path: "/main/FirstPaymentReward",
		name: "FirstPaymentReward",
		meta: {
			title: "（渠道代）首笔合同款奖励查询" 
		},
		component: () =>
			import("@/views/Home/ChannelAgents/FirstPaymentReward/index.vue"),
	},
	{
		path: "/main/AgentFirstPaymentReward",
		name: "FirstPaymentReward",
		meta: {
			title: "（代理商）首笔合同款奖励查询" 
		},
		component: () =>
			import("@/views/Home/ChannelAgents/AgentFirstPaymentReward/index.vue"),
	},
	{
		path: "/main/RegionCustomers",
		name: "RegionCustomers",
		meta: {
			title: "（代理商）区域内转介绍客户" 
		},
		component: () =>
			import("@/views/Home/ChannelAgents/RegionCustomers/index.vue"),
	},
	{
		path: "/main/ChannelManagement",
		name: "ChannelManagement",
		meta: {
			title: "渠道代管理" 
		},
		component: () =>
			import("@/views/Home/ChannelAgents/ChannelManagement/index.vue"),
	},
	{
		path: "/main/ChannelManagementDetail",
		name: "ChannelManagementDetail",
		meta: {
			title: "渠道代详情",
		},
		component: () =>
			import("@/views/Home/ChannelAgents/ChannelManagement/ChannelManagementDetail.vue"),
	},
	{
		path: "/main/RebatesAndFees",
		name: "RebatesAndFees",
		meta: {
			title: "（代理商）渠道代返佣和服务费查询" 
		},
		component: () =>
			import("@/views/Home/ChannelAgents/RebatesAndFees/index.vue"),
	},
	{
		path: "/main/ChannelRebatesAndFees",
		name: "ChannelRebatesAndFees",
		meta: {
			title: "渠道代返佣和服务费查询" 
		},
		component: () =>
			import("@/views/Home/ChannelAgents/ChannelRebatesAndFees/index.vue"),
	}
]